import React from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { Button, TextLink, Typography } from '@guildeducationinc/recess';
import { CONTACT_SUPPORT_URL, HOME_URL } from 'src/utilities/envConfig';
import styles from './Variants.module.scss';

export const TacoBellFranchiseEmptyCatalog: React.FC = () => {
	return (
		<>
			<div className={styles.content}>
				<Typography className={styles.title} variant='h1'>
					Sorry, new applications will not be accepted at this time.
				</Typography>
				<Typography variant='body1'>
					At this time new applications will no longer be accepted for the Guild benefit. Those who
					are currently actively participating in a program will receive additional communication on
					how they can access the benefit to finish their programs.
				</Typography>
			</div>
		</>
	);
};

export const WalmartEmptyCatalog: React.FC = () => {
	return (
		<>
			<div className={styles.content}>
				<Typography variant='body2'>
					To see open programs, please visit{' '}
					<TextLink href='http://Livebetteru.com' size='large' target='_blank'>
						www.livebetteru.com
					</TextLink>
					.
				</Typography>
				<Typography gutterTop='sm' variant='body2'>
					Reach out to{' '}
					<TextLink href={CONTACT_SUPPORT_URL} size='large' target='_blank'>
						Guild support
					</TextLink>{' '}
					with questions about continuing in your program if you have previously enrolled.
				</Typography>
			</div>
		</>
	);
};

export const GenericEmptyCatalog: React.FC = () => {
	const isMobile = useIsMobile();

	return (
		<>
			<div className={styles.content}>
				<Typography className={styles.title} variant='h1'>
					You don&apos;t have any covered programs
				</Typography>
				<Typography noWrap={!isMobile} variant='body1'>
					It looks like there aren&apos;t any education programs covered by your benefit right now.
				</Typography>
			</div>
			<div className={styles.cta}>
				<Button className={styles.homeButton} href={HOME_URL}>
					Go to Home
				</Button>
				<Typography className={styles.anchorText} variant='body1'>
					Do you think this is an error?{' '}
					<TextLink className={styles.anchor} href={CONTACT_SUPPORT_URL} target='_blank'>
						Contact Guild support
					</TextLink>
				</Typography>
			</div>
		</>
	);
};
